/*
 * util for mapping billing terms to checkout copy
 */
function TermDefs() {

	// (rebill_months,rebill_weeks,num_cycles) -> {}
	var termMap = {

		// adhoc
		"[null,null,1]": {
			cardTop: '1 Month',
			cycleAbbr: 'mo',
			autoRenews: 'monthly',
			perCycle: 'per month'
		},
		"[null,null,3]": {
			cardTop: '3 Months',
			cycleAbbr: 'mo',
			autoRenews: 'every 3 months',
			perCycle: 'per month'
		},
		"[null,null,6]": {
			cardTop: '6 Months',
			cycleAbbr: 'mo',
			autoRenews: 'every 6 months',
			perCycle: 'per month'
		},
		"[null,null,12]": {
			cardTop: '12 Months',
			cycleAbbr: 'mo',
			autoRenews: 'every 12 months',
			perCycle: 'per month'
		},

		// monthly
		"[1,null,1]": {
			cardTop: '1 Month',
			cycleAbbr: 'mo',
			autoRenews: 'monthly',
			perCycle: 'per month'
		},
		"[1,null,3]": {
			cardTop: '3 Months',
			cycleAbbr: 'mo',
			autoRenews: 'every 3 months',
			perCycle: 'per month'
		},
		"[1,null,6]": {
			cardTop: '6 Months',
			cycleAbbr: 'mo',
			autoRenews: 'every 6 months',
			perCycle: 'per month'
		},
		"[1,null,12]": {
			cardTop: '12 Months',
			cycleAbbr: 'mo',
			autoRenews: 'every 12 months',
			perCycle: 'per month'
		},

		// weekly
		"[null,1,1]": {
			cardTop: '1 Week',
			cycleAbbr: 'wk',
			autoRenews: 'weekly',
			perCycle: 'per week'
		},
		"[null,1,2]": {
			cardTop: '2 Weeks',
			cycleAbbr: 'wk',
			autoRenews: 'every 2 weeks',
			perCycle: 'per week'
		},
		"[null,1,4]": {
			cardTop: '4 Weeks',
			cycleAbbr: 'wk',
			autoRenews: 'every 4 weeks',
			perCycle: 'per week'
		},
		"[null,1,8]": {
			cardTop: '8 weeks',
			cycleAbbr: 'wk',
			autoRenews: 'every 8 weeks',
			perCycle: 'per week'
		},

		// quarterly
		"[3,null,1]": {
			cardTop: '1 Box Every 3 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 3 months',
			perCycle: 'per 3-month cycle'
		},
		"[3,null,2]": {
			cardTop: '2 Boxes Over 6 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 6 months',
			perCycle: 'per 3-month cycle'
		},
		"[3,null,4]": {
			cardTop: '4 Boxes Over 12 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 12 months',
			perCycle: 'per 3-month cycle'
		},
		"[3,null,6]": {
			cardTop: '6 Boxes Over 18 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 18 months',
			perCycle: 'per 3-month cycle'
		},

		// bi-monthly
		"[2,null,1]": {
			cardTop: '1 Box Every 2 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 2 months',
			perCycle: 'per 2-month cycle'
		},
		"[2,null,2]": {
			cardTop: '2 Boxes Over 4 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 4 months',
			perCycle: 'per 2-month cycle'
		},
		"[2,null,3]": {
			cardTop: '3 Boxes Over 6 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 6 months',
			perCycle: 'per 2-month cycle'
		},
		"[2,null,4]": {
			cardTop: '4 Boxes Over 8 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 8 months',
			perCycle: 'per 2-month cycle'
		},
		"[2,null,6]": {
			cardTop: '6 Boxes Over 12 Months',
			cycleAbbr: 'box',
			autoRenews: 'every 12 months',
			perCycle: 'per 2-month cycle'
		},

		// bi-weekly
		"[null,2,1]": {
			cardTop: '1 Box Every 2 Weeks',
			cycleAbbr: 'box',
			autoRenews: 'every 2 weeks',
			perCycle: 'per 2-week cycle'
		},
		"[null,2,2]": {
			cardTop: '2 Boxes Over 4 Weeks',
			cycleAbbr: 'box',
			autoRenews: 'every 4 weeks',
			perCycle: 'per 2-week cycle'
		},
		"[null,2,4]": {
			cardTop: '4 Boxes Over 8 Weeks',
			cycleAbbr: 'box',
			autoRenews: 'every 8 weeks',
			perCycle: 'per 2-week cycle'
		},
		"[null,2,8]": {
			cardTop: '8 Boxes Over 16 Weeks',
			cycleAbbr: 'box',
			autoRenews: 'every 16 weeks',
			perCycle: 'per 2-week cycle'
		}

	};

	var getTermBlob = function(rebillMonths, rebillWeeks, numCycles) {
		if (rebillMonths === 0) rebillMonths = null;
		if (rebillWeeks === 0) rebillWeeks = null;
		// returns an object with pre-rendered term verbiage given the inputs
		var termKey = JSON.stringify([rebillMonths, rebillWeeks, numCycles]);

		if (!(termKey in termMap)) {
			// fallback so thing dont die
			let term = rebillWeeks ? 'Weeks' : 'Months';
			let duration = (rebillMonths || rebillWeeks) * numCycles;
			return {
				cardTop: `${numCycles} Boxes Over ${duration} ${term}`,
				cycleAbbr: 'box',
				autoRenews: `every ${duration} ${term.toLowerCase()}`,
				perCycle: 'per cycle'
			}
		}

		return termMap[termKey];
	};

	return {
		getTermBlob: getTermBlob
	};

}

if (typeof require === 'function' && typeof exports !== 'undefined') {
	module.exports = TermDefs();
} else {
	define([], TermDefs);
}
